var exports = {
  "Testimonials": "Testimonials__aI2Mbi",
  "Testimonials__quotes": "Testimonials__quotes__44PLu4",
  "Testimonials__stats": "Testimonials__stats__dHqq-6",
  "Testimonials__stat": "Testimonials__stat__Mnxlqt",
  "Testimonials__statValue": "Testimonials__statValue__GX4gx-",
};

__webpack_require__.r(module.exports = exports);
